import React, { useState } from "react";
import './quejas.css';
import ReCAPTCHA from "react-google-recaptcha";
export default function App() {
  const municipios = [
    "1. Acatlán", "2. Acaxochitlán", "3. Actopan", "4. Agua Blanca de Iturbide", "5. Ajacuba", "6. Alfajayucan", "7. Almoloya", "8. Apan", "9. El Arenal", "10. Atitalaquia", "11. Atlapexco", "12. Atotonilco el Grande", "13. Atotonilco de Tula", "14. Calnali", "15. Cardonal", "16. Cuautepec de Hinojosa", "17. Chapantongo", "18. Chapulhuacán", "19. Chilcuautla", "20. Eloxochitlán", "21. Emiliano Zapata", "22. Epazoyucan", "23. Francisco I. Madero", "24. Huasca de Ocampo", "25. Huautla", "26. Huazalingo", "27. Huehuetla", "28. Huejutla de Reyes", "29. Huichapan", "30. Ixmiquilpan", "31. Jacala de Ledezma", "32. Jaltocán", "33. Juárez Hidalgo", "34. Lolotla", "35. Metepec", "36. San Agustín Metzquititlán", "37. Metztitlán", "38. Mineral del Chico", "39. Mineral del Monte", "40. La Misión", "41. Mixquiahuala de Juárez", "42. Molango de Escamilla", "43. Nicolás Flores", "44. Nopala de Villagrán", "45. Omitlán de Juárez", "46. San Felipe Orizatlán", "47. Pacula", "48. Pachuca de Soto", "49. Pisaflores", "50. Progreso de Obregón", "51. Mineral de la Reforma", "52. San Agustín Tlaxiaca", "53. San Bartolo Tutotepec", "54. San Salvador", "55. Santiago de Anaya", "56. Santiago Tulantepec de Lugo", "57. Singuilucan", "58. Tasquillo", "59. Tecozautla", "60. Tenango de Doria", "61. Tepeapulco", "62. Tepehuacán de Guerrero", "63. Tepeji del Río de Ocampo", "64. Tepetitlán", "65. Tetepango", "66. Villa de Tezontepec", "67. Tezontepec de Aldama", "68. Tianguistengo", "69. Tizayuca", "70. Tlahuelilpan", "71.Tlahuiltepa", "72. Tlanalapa", "73. Tlanchinol", "74. Tlaxcoapan", "75. Tolcayuca", "76. Tula de Allende", "77. Tulancingo de Bravo", "78. Xochiatipan", "79. Xochicoatlán", "80. Yahualica", "81. Zacualtipán de Ángeles", "82. Zapotlán de Juárez", "83. Zempoala", "84. Zimapán"
  ];
  const [isRecaptchaVerified, setIsRecaptchaVerified] = useState(false); 
  function onChange(value) {
    console.log("Captcha value:", value);
    setIsRecaptchaVerified(value ? true : false);
  }
  function generateUniqueFolio() {
    const randomId = Math.floor(Math.random() * 100000); 
    const uniqueFolio = `FOLIO-${randomId}`;
    return uniqueFolio;
  }
  function Submit(e) {
    const formEle = document.querySelector("form")
    const folio = generateUniqueFolio();
    const folioField = document.getElementById('folioField');
    folioField.value = folio;
console.log(folio);
    e.preventDefault()
    console.log("subnitted")
    const formData= new FormData(formEle)
    if (!isRecaptchaVerified) {
      alert("Por favor, complete el reCAPTCHA antes de enviar la queja.");
      return;
    }
    const requiredFields = ["Nombre", "Telefono", "Correo", "Fecha", "Hora", "Placas", "Queja","Municipio" ];
    let isFormValid = true;

    requiredFields.forEach(fieldName => {
      const fieldElement = formEle.elements[fieldName];
      if (!fieldElement.value) {
        alert(`Por favor, complete el campo "${fieldName}".`);
        isFormValid = false;
      }
    });

    if (!isFormValid) {
      return;
    }
    fetch("https://script.google.com/macros/s/AKfycbx09omRuw15Ngi8b1HnUzFeBJ5nki4od2XiqxLYZ6U1saiboFKLDrJKwIwu8mtYDtUYEA/exec",
      {
        method: "POST",
        body: formData
      }
    )
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
      })
      .catch((error) => {
        console.log(error);
        alert(`Su queja ha sido remitida a la Secretaría de Movilidad y Transporte: ${folio}` );
        <input type="hidden" name="Folio" id="folioField" />
        window.location.href = "https://movilidadytransporte.hidalgo.gob.mx/";
        e.target.reset();
     });
  }
    const [isLEYESCollapsed, setIsLEYESCollapsed] = useState(true);
    const [subMenu1Collapsed, setSubMenu1Collapsed] = useState(true);
    return (
      <div className="container container-mh">
      <div className="titlesecundario">
      <h1>Quejas </h1>
        <br></br>
        <hr className="hr-gob" />
        <div className='container-armon'>
          <h3>Conoce más acerca del proceso de quejas del transporte público a tráves de este portal de la Secretaría de Movilidad y Transporte.  </h3>
          <p><li>La atención a los usuarios es inmediata y su seguimiento es en un plazo aproximado de 15 a 20 días hábiles. </li>     
        <li>Accidentes y servicios auxiliares (grúas y depósitos vehiculares) el seguimiento es en un plazo no mayor a 5 días hábiles.</li>
        <li>En caso de que el quejoso sea menor de edad, lo puede representar alguien mayor de edad que acredite su parentesco.</li></p>
        </div>
        
        <div className="contenido-button-group">
                <button className="btn btn-primary contenido-button" type="button" onClick={() => setIsLEYESCollapsed(!isLEYESCollapsed)} aria-expanded={!isLEYESCollapsed}> Normatividad</button>
                <p></p>
                <div className={`multi-collapse collapse ${isLEYESCollapsed ? '' : 'show'}`} id="leyes-menu">
                  <button
                    className="btn btn-primary contenido-button"
                    type="button"
                    onClick={() => setSubMenu1Collapsed(!subMenu1Collapsed)}
                    aria-expanded={!subMenu1Collapsed}
                  >
                    Secretaría de Movilidad y Transporte
                  </button>
                  <p></p>
                  <div className={`multi-collapse armo-collapse collapse ${subMenu1Collapsed ? '' : 'show'}`} id="lista-0-0">
                    <a
                      href="http://www.congreso-hidalgo.gob.mx/biblioteca_legislativa/leyes_cintillo/Ley%20de%20Movilidad%20y%20Transporte%20para%20el%20Estado%20de%20Hidalgo.pdf"
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-primary btn-armo-collapse btn-dorado"
                    >
                      1.1  Ley de Movilidad y Transporte para el Estado de Hidalgo
                    </a>
                    <p></p>
                    <a
                      href="https://transparenciadocs.hidalgo.gob.mx/dependencias/Semot/dir3/REGLAMENTOLMTH2020.pdf"
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-primary btn-armo-collapse btn-dorado"
                    >
                      1.2  Reglamento de la Ley de Movilidad y Transporte para el Estado de Hidalgo
                    </a>
                </div>
             </div>
          </div> 
          <br></br>
         <hr className="hr-gob" />
         <div className='row'>
         <div class="col-sm-6 col-12">
         <img src="assets/imgs/1.jpg" alt= "" className="img-personalizada" />
         </div>
         <br></br>
         <div class="col-sm-6 col-12">
        <div className="contornoform">
    <div className="App">
      <h1>Formulario de Quejas</h1>
      <br></br>
      <div>
        <form className="form" onSubmit={(e) => Submit(e)}>
        <label htmlFor="name">Nombre y apellido del solicitante</label>
        <br></br>
        <input placeholder="Andrés Yáñez Pérez" name="Nombre" type="text" required/>
        <br></br>
        <p></p>
        <label htmlFor="phone">Teléfono</label>
        <br></br>
        <input placeholder="771-000-0000" name="Telefono" type="text" required/>
        <br></br>
        <p></p>
        <label htmlFor="email">Correo Electrónico</label>
        <br></br>
        <input placeholder="tucorreo@correo.com" name="Correo" type="email" required/>
        <br></br>
        <p></p>
        <label htmlFor="dateOfIncident">Fecha del Suceso</label>
        <br></br>
        <input placeholder="Fecha del suceso" name="Fecha" type="date" required/>
        <br></br>
        <p></p>
        <label htmlFor="timeOfIncident">Hora del Suceso</label>
        <br></br>
        <input placeholder="Hora del suceso" name="Hora" type="time" required/>
        <br></br>
        <p></p>
        <label htmlFor="unitPlates">Placas de la Unidad</label>
        <br></br>
        <input placeholder="A-000-00-A" name="Placas" type="text" required/>
        <br></br>
        <p></p>
        <label htmlFor="complaint">Queja</label>
        <br></br>
        <input placeholder="Queja" name="Queja" type="Menssage" required/>
        <br></br>
        <label htmlFor="Municipio">Municipio</label>
        <br></br>
        <select name="Municipio" required >
        <option value="" disabled selected>Selecciona un municipio</option>
        {municipios.map((municipio, index) => (
        <option key={index} value={municipio}>
        {municipio}
        </option>
        ))}
        </select>
          <br></br>
          <p></p>
          <br></br>
        <div className="recaptcha">
        <ReCAPTCHA
        sitekey="6Lfa4v0oAAAAAL3ePRxzPzUijvzGsKLxuiYwi0M0"
        onChange={onChange}
        /></div>
        <input type="hidden" name="Folio" id="folioField" />
        <button className="btn-doradodespacho" type="submit" onclick="alert" >Enviar Queja</button>
        <p></p>
        </form>
      </div>
      </div>
      </div>
      </div>
      </div>
      <br></br>
      <hr className="hr-gob" />
      </div> 
      </div>
    );
}
